
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class LogisticOrderService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.data_url =
      appData.serviceURL + `/${process.env.REACT_APP_LO_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }

  static getLogisticOrderPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getLogisticOrderPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static initLogisticOrderModule(input, responseCallBack, errorCallBack) {
    this.method(
      "initLogisticOrderModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readLogisticOrder(input, responseCallBack, errorCallBack) {
    this.method("readLogisticOrder", input, responseCallBack, errorCallBack);
  }
  static unLockLogisticOrderNumber(input, responseCallBack, errorCallBack) {
    this.method(
      "unLockLogisticOrderNumber",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static createLogisticOrder(input, responseCallBack, errorCallBack) {
    this.method("createLogisticOrder", input, responseCallBack, errorCallBack);
  }
  static approveLogisticOrder(input, responseCallBack, errorCallBack) {
    this.method("approveLogisticOrder", input, responseCallBack, errorCallBack);
  }
  static createAndApproveLogisticOrder(input, responseCallBack, errorCallBack) {
    this.method(
      "createAndApproveLogisticOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateLogisticOrder(input, responseCallBack, errorCallBack) {
    this.method("updateLogisticOrder", input, responseCallBack, errorCallBack);
  }
  static updateAndApproveLogisticOrder(input, responseCallBack, errorCallBack) {
    this.method(
      "updateAndApproveLogisticOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unApproveLogisticOrder(input, responseCallBack, errorCallBack) {
    this.method(
      "unApproveLogisticOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelLogisticOrder(input, responseCallBack, errorCallBack) {
    this.method("cancelLogisticOrder", input, responseCallBack, errorCallBack);
  }

  static logisticOrderImageUpload(input, responseCallBack, errorCallBack) {
    this.method(
      "logisticOrderImageUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static logisticOrderDocUpload(input, responseCallBack, errorCallBack) {
    this.method(
      "logisticOrderDocUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateLogisticOrderAfterApproval(input, responseCallBack, errorCallBack) {
    this.method(
      "updateLogisticOrderAfterApproval",
      input,
      responseCallBack,
      errorCallBack
    );
  }  

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     // Accept: "application/json",
      //     "Content-Type": "application/json",
      //      ...(isFormData ? {} : { "Content-Type": "application/json" })
      //   },
      // })
      // //  Contentformat.Contentformattype(methodName, input,this.data_url,responseCallBack, errorCallBack);
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
       ServiceExecutorProxy.executeService(methodName, input,this.data_url,responseCallBack, errorCallBack);

    }
  }
}
